const mvSlider = () => {
  //@ts-ignore
  new Splide('.js-mv-img-slider', {
    type: 'fade',
    rewind: true,
    focus: 'center',
    autoplay: true,
    arrows: false,
    pagination: false,
  }).mount();
};

export default mvSlider;